<form autocomplete="off" class="p-0" novalidate [formGroup]="additionalDetailsForm">
    <div class="col-lg-12 col-md-12">
             <div class="mt-3">
                <div>
                    <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/credit-card.png"
                    class="mh-45px mrl mt-1 pb-2">
                        Additional Details</b></h3>
                </div>
                <div class="row clearfix">     
                    
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuAadhar'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuAadhar'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuAadhar'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select matTooltip="Do You Have Aadhar Card?" formControlName="StuAadhar" #select144 placeholder="Select" class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option [value] = 1 (click)="Aadhar(1)">Yes</mat-option>
                                        <mat-option [value] = 2 (click)="Aadhar(2)">No</mat-option>
                                      </mat-select>
                                      <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuAadhar'].touched && additionalDetailsForm.controls['StuAadhar'].errors?.required">
                               Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div *ngIf="additionalDetailsFormArray['StuAadhaarNo'][0]['FormVisible']">
                            <div class="form-group">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>{{additionalDetailsFormArray['StuAadhaarNo'][0]['FormDisplayName']}}
                                            <span *ngIf="additionalDetailsFormArray['StuAadhaarNo'][0]['FormRequired']">*</span>
                                        </mat-label>
                                        <input formControlName="StuAadhaarNo" matInput placeholder="Aadhaar Number" minlength="12" maxlength="12" >
                                        <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuAadhaarNo'].touched && additionalDetailsForm.controls['StuAadhaarNo'].errors?.required">
                                       Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuAadhaarNo'].touched && additionalDetailsForm.controls['StuAadhaarNo'].errors?.minlength">
                                        Enter Minimum 12 Digit.
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuAadhaarNo'].touched && additionalDetailsForm.controls['StuAadhaarNo'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                    </mat-form-field>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuVoterId'][0]['FormVisible']" >
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{additionalDetailsFormArray['StuVoterId'][0]['FormDisplayName']}}
                                    <span *ngIf="additionalDetailsFormArray['StuVoterId'][0]['FormRequired']">*</span>
                                    </mat-label>
                                <input formControlName="StuVoterId" matInput placeholder="Voter Id" maxlength="10" minlength="10">
                                <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuVoterId'].touched && additionalDetailsForm.controls['StuVoterId'].errors?.required">
                               Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuVoterId'].touched && additionalDetailsForm.controls['StuVoterId'].errors?.pattern">
                                Invalid
                            </mat-error>
                            <mat-error class="margin_tp"
                            *ngIf="additionalDetailsForm.controls['StuVoterId'].touched && additionalDetailsForm.controls['StuVoterId'].errors?.minlength">
                            Enter Minimum 10 Digit.
                        </mat-error>
                            </mat-form-field>
                           
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuPanNo'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuPanNo'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuPanNo'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input formControlName="StuPanNo" matInput placeholder="LIOKO9000O" maxlength="10">
                                    <mat-error class="margin_tp"
                                    *ngIf="additionalDetailsForm.controls['StuPanNo'].touched && additionalDetailsForm.controls['StuPanNo'].errors?.required">
                                   Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="additionalDetailsForm.controls['StuPanNo'].touched && additionalDetailsForm.controls['StuPanNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                </mat-form-field>
                        </div> 
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuPassPort'][0]['FormVisible']">
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{additionalDetailsFormArray['StuPassPort'][0]['FormDisplayName']}}
                                    <span *ngIf="additionalDetailsFormArray['StuPassPort'][0]['FormRequired']">*</span>
                                    </mat-label>
                                <input matInput placeholder="Passport Number" formControlName="StuPassPort" maxlength="8">
                                <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuPassPort'].touched && additionalDetailsForm.controls['StuPassPort'].errors?.required">
                               Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                            *ngIf="additionalDetailsForm.controls['StuPassPort'].touched && additionalDetailsForm.controls['StuPassPort'].errors?.pattern">
                            Invalid
                        </mat-error>
                        <!-- <mat-error class="margin_tp"
                            *ngIf="additionalDetailsForm.controls['StuPassPort'].touched && additionalDetailsForm.controls['StuPassPort'].errors?.minlength">
                            Enter Minimum 8 Digit.
                        </mat-error> -->
                            </mat-form-field>
                           
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuFromDate'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuFromDate'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuFromDate'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput [matDatepicker]="dob" id="dob" formControlName="StuFromDate"
                                    placeholder="DD/MM/YYYY" >
                                  <mat-datepicker-toggle matSuffix [for]="dob">
                                  </mat-datepicker-toggle>
                                  <mat-datepicker #dob></mat-datepicker>
                                  <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuFromDate'].touched && additionalDetailsForm.controls['StuFromDate'].errors?.required">
                               Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                            *ngIf="additionalDetailsForm.controls['StuFromDate'].touched && additionalDetailsForm.controls['StuFromDate'].errors?.pattern">
                            Invalid
                        </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuToDate'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuToDate'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuToDate'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput [matDatepicker]="validTill" id="validTill" 
                                    formControlName="StuToDate" (dateChange)="todate($event)"
                                    placeholder="DD/MM/YYYY" >
                                  <mat-datepicker-toggle matSuffix [for]="validTill">
                                  </mat-datepicker-toggle>
                                  <mat-datepicker #validTill></mat-datepicker>
                                  <mat-error class="margin_tp"
                                  *ngIf="additionalDetailsForm.controls['StuToDate'].touched && additionalDetailsForm.controls['StuToDate'].errors?.required">
                                 Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                                  *ngIf="additionalDetailsForm.controls['StuToDate'].touched && additionalDetailsForm.controls['StuToDate'].errors?.pattern">
                                 Invalid
                              </mat-error>
                                </mat-form-field>
                               
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuOrgDonate'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuOrgDonate'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuOrgDonate'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuOrgDonate" #select14 placeholder="Select" class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                      </mat-select>
                                      <mat-error class="margin_tp"
                                      *ngIf="additionalDetailsForm.controls['StuOrgDonate'].touched && additionalDetailsForm.controls['StuOrgDonate'].errors?.required">
                                     Mandatory
                                  </mat-error>
                                </mat-form-field>
                               
                        </div>
                    </div>
                    <!-- <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuHostelAccod'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuHostelAccod'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuHostelAccod'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuHostelAccod" #select104 placeholder="Select" class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                      </mat-select>
                                      <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuHostelAccod'].touched && additionalDetailsForm.controls['StuHostelAccod'].errors?.required">
                               Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div> -->
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuDriLiceNo'][0]['FormVisible']">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuDriLiceNo'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuDriLiceNo'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput placeholder="MH09 90090909090" maxlength="16" formControlName="StuDriLiceNo">
                                    
                                <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuDriLiceNo'].touched && additionalDetailsForm.controls['StuDriLiceNo'].errors?.required">
                               Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                            *ngIf="additionalDetailsForm.controls['StuDriLiceNo'].touched && additionalDetailsForm.controls['StuDriLiceNo'].errors?.pattern">
                            Invalid
                        </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuFmlyInc'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuFmlyInc'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuFmlyInc'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput placeholder="Family Income" formControlName="StuFmlyInc" maxlength="10">
                                    <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuFmlyInc'].touched && additionalDetailsForm.controls['StuFmlyInc'].errors?.required">
                               Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuFmlyInc'].touched && additionalDetailsForm.controls['StuFmlyInc'].errors?.pattern">
                                Invalid
                            </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuEmpType'][0]['FormVisible']">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuEmpType'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuEmpType'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuEmpType"  placeholder="Employee Type"
                                        class="colorblack" #select17>
                                        <mat-select-filter *ngIf="select17.focused" [placeholder]="'Filter'"
                                            [displayMember]="'CdDesc'" [array]="EmpTypeCodeList"
                                            (filteredReturn)="filteredListEmpTypeCode =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListEmpTypeCode"
                                            [value]="item.CdCode">
                                            {{item.CdDesc}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuEmpType'].touched && additionalDetailsForm.controls['StuEmpType'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuABCId'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuABCId'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuABCId'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select matTooltip="Do You Have an ABC ID?" formControlName="StuABCId" #select143 placeholder="Select" class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option [value]=1 (click)="AdharContact(1)">Yes</mat-option>
                                        <mat-option [value]=2 (click)="AdharContact(2)">No</mat-option>
                                      </mat-select>
                                      <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuABCId'].touched && additionalDetailsForm.controls['StuABCId'].errors?.required">
                               Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div> -->
                    <div class="col-sm-2">
                        <div *ngIf="additionalDetailsFormArray['StuABCId2'][0]['FormVisible']">
                            <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuABCId2'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuABCId2'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput placeholder="ABC ID" formControlName="StuABCId2" maxlength="12">
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuABCId2'].touched && additionalDetailsForm.controls['StuABCId2'].errors?.required">
                                    Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuABCId2'].touched && additionalDetailsForm.controls['StuABCId2'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['StuABCId2'].touched && (additionalDetailsForm.controls['StuABCId2'].errors?.minlength || additionalDetailsForm.controls['StuABCId2'].errors?.maxlength)">
                                        12 digits are required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2"  *ngIf="AdharPhone">
                        <div *ngIf="additionalDetailsFormArray['StuAadharPhone'][0]['FormVisible']">
                            <div class="form-group">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>{{additionalDetailsFormArray['StuAadharPhone'][0]['FormDisplayName']}}
                                            <span *ngIf="additionalDetailsFormArray['StuAadharPhone'][0]['FormRequired']">*</span>
                                        </mat-label>
                                        <input matTooltip="If no, Please provide your Adhaar Link Phone Number" matInput placeholder="Aadhar Linked Phone Number" formControlName="StuAadharPhone" maxlength="10">
                                        <mat-error class="margin_tp"
                                    *ngIf="additionalDetailsForm.controls['StuAadharPhone'].touched && additionalDetailsForm.controls['StuAadharPhone'].errors?.required">
                                   Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="additionalDetailsForm.controls['StuAadharPhone'].touched && additionalDetailsForm.controls['StuAadharPhone'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                    </mat-form-field>
                                    
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuDistrictAd'][0]['FormVisible']">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuDistrictAd'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuDistrictAd'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuDistrictAd"  placeholder="District"
                                        class="colorblack" #select176>
                                        <mat-select-filter *ngIf="select176.focused" [placeholder]="'Filter'"
                                            [displayMember]="'DsName'" [array]="districtList"
                                            (filteredReturn)="filteredListdistrictCode =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListdistrictCode"
                                            [value]="item.DsCode" (click)="getCollegeData(item.DsCode)">
                                            {{item.DsName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuDistrictAd'].touched && additionalDetailsForm.controls['StuDistrictAd'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuStudyCenter'][0]['FormVisible']">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuStudyCenter'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuStudyCenter'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuStudyCenter"  placeholder="Study Center"
                                        class="colorblack" #select177>
                                        <mat-select-filter *ngIf="select177.focused" [placeholder]="'Filter'"
                                            [displayMember]="'CgName'" [array]="collegedataList"
                                            (filteredReturn)="filteredListCollege =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListCollege"
                                            [value]="item.CgCode">
                                            {{item.CgName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuStudyCenter'].touched && additionalDetailsForm.controls['StuStudyCenter'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="additionalDetailsFormArray['StuMedium'][0]['FormVisible']">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['StuMedium'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['StuMedium'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select formControlName="StuMedium"  placeholder="Medium"
                                        class="colorblack" #select178>
                                        <mat-select-filter *ngIf="select178.focused" [placeholder]="'Filter'"
                                            [displayMember]="'CdDesc'" [array]="MediumCodeList"
                                            (filteredReturn)="filteredListMediumCode =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListMediumCode"
                                            [value]="item.CdCode">
                                            {{item.CdDesc}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['StuMedium'].touched && additionalDetailsForm.controls['StuMedium'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-2" *ngIf="additionalDetailsFormArray['otherCourseAddi'][0]['FormVisible']">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['otherCourseAddi'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['otherCourseAddi'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <mat-select matTooltip="Pursuing for other course?" formControlName="otherCourseAddi" #select143 placeholder="Select" class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option [value]=1 (click)="pursuingOtherCourse(1)">Yes</mat-option>
                                        <mat-option [value]=2 (click)="pursuingOtherCourse(2)">No</mat-option>
                                      </mat-select>
                                      <mat-error class="margin_tp"
                                *ngIf="additionalDetailsForm.controls['otherCourseAddi'].touched && additionalDetailsForm.controls['otherCourseAddi'].errors?.required">
                               Mandatory
                            </mat-error>
                                </mat-form-field>
                                
                        </div>
                    </div>
                    <div class="col-sm-2" *ngIf="otherCourse">
                        <div *ngIf="additionalDetailsFormArray['courseNameAddi'][0]['FormVisible']">
                            <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>{{additionalDetailsFormArray['courseNameAddi'][0]['FormDisplayName']}}
                                        <span *ngIf="additionalDetailsFormArray['courseNameAddi'][0]['FormRequired']">*</span>
                                    </mat-label>
                                    <input matInput placeholder="Course Name" formControlName="courseNameAddi" maxlength="12">
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['courseNameAddi'].touched && additionalDetailsForm.controls['courseNameAddi'].errors?.required">
                                    Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="additionalDetailsForm.controls['courseNameAddi'].touched && additionalDetailsForm.controls['courseNameAddi'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div> -->
                        <span class="update-section" *ngIf="CourseLevel === 'phd'">
                            <span class="d-inline-flex align-items-center">
                                <label class="fw-bold d-block">
                                    Work Experience in Goverment/Private Sector  
                                </label>
                                <mat-radio-group formControlName="WorkExperience" class="d-flex align-items-center">
                                    <mat-radio-button value="Y" class="me-2">
                                        Yes
                                    </mat-radio-button>
                                    <mat-radio-button value="N">
                                        No
                                    </mat-radio-button>
                                </mat-radio-group>
                            </span>
                        </span>
                    <div class="row mb-2 prpl">
                        <div class="col-sm-12">
                            <button type="button"  *ngIf="submitButton"
                                class="btn btn-primary btn-icon-text fr sz floatright mt-1"
                                (click)="submitAdditionalDetails()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/images/save.gif"
                                        style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button type="button"  *ngIf="updateButton" [disabled]="disabled" (click)="updateAdditionalDetails()"
                            class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/edit.gif"
                                    style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                            <button type="button" (click)="back()"
                            class="btn btn-primary btn-icon-text floatright fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-left.gif"
                                    style="margin-right: 5px;">
                               Back
                            </span>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</form>